"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const composition_api_1 = require("@vue/composition-api");
const Container_hooks_1 = require("./Container.hooks");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.Container = composition_api_1.defineComponent({
    name: 'Container',
    props: Container_hooks_1.containerProps,
    setup: Container_hooks_1.useContainer,
    template: `
    <component :class="{ '--empty': !definition.modules.length }"
               :is="resolvedComponent" :data="resolvedContent" v-bind="elementProps">
      <component v-if="gridTemplate" is="style" v-html="gridTemplate" />
      <div :class="innerClass" :id="definition.container"
           v-bind="showControls ? { tabindex: 0, role: 'listbox' } : null"
           @focus="$emit('click')" @blur="$emit('click')"><slot /></div>
  
      <div v-if="showControls" class="handler --container-handler">
        <i class="fa fa-arrows-alt-v"></i>
      </div>
  
      <div class="builder__container-controls controls" v-if="showControls">
        <button v-if="controls.editContainer" type="button" class="control"
                @click.stop="triggerEvent('editContainer')" @mousedown.prevent>
          <i class="fa fa-pen"></i>
        </button>
        <button v-if="controls.copyContainer" type="button" class="control"
                @click.stop="triggerEvent('copy')" @mousedown.prevent>
          <i class="fa fa-copy"></i>
        </button>
        <button v-if="controls.cloneContainer" type="button" class="control"
                @click.stop="clone" @mousedown.prevent>
          <i class="fa fa-clone"></i>
        </button>
        <button v-if="controls.removeContainer" type="button" class="control"
                @click.stop="triggerEvent('removeContainer')" @mousedown.prevent>
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </component>
  `
});
//# sourceMappingURL=Container.js.map